module.exports = __webpack_public_path__ + "img/叶坪中华苏维埃共和国中央警卫营旧址.195d099b.png";